/* eslint-disable @typescript-eslint/no-explicit-any */
import { format } from "date-fns";

import { SwitchRenderer } from "@/components/shared/switch-renderer";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const ReactTableCell = ({ header, value, row }: any) => {
  switch (header) {
    case "status": {
      return (
        <SwitchRenderer
          type={value}
          components={{
            processed: (
              <span className="text-green-500 bg-green-50 py-1 border-green-100 border px-3 rounded-[50px] inline-block">
                {value}
              </span>
            ),
            success: (
              <span className="text-green-500 bg-green-50 py-1 border-green-100 border px-3 rounded-[50px] inline-block">
                {value}
              </span>
            ),
            queued: (
              <span className="text-green-500 bg-green-50 py-1 border-green-100 border px-3 rounded-[50px] inline-block">
                {value}
              </span>
            ),
            failed: (
              <TooltipProvider delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger className="text-left line-clamp-1">
                    <span className="text-red-500 bg-red-50 py-1 border border-red-100 px-3 rounded-[50px] inline-block">
                      {value}
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>
                    <TooltipArrow />
                    <p>{row?.error}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            ),
            error: (
              <TooltipProvider delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger className="text-left line-clamp-1">
                    <span className="text-red-500 bg-red-50 py-1 border border-red-100 px-3 rounded-[50px] inline-block">
                      {value}
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>
                    <TooltipArrow />
                    <p>{row?.error}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            ),
            default: <Badge variant={"outline"}>{value}</Badge>,
          }}
        />
      );
    }

    case "received_at":
    case "cts": {
      if (!value) return <span>-</span>;
      try {
        const formattedDate = format(new Date(value), "dd-MM-yyyy hh:mm a");
        return <span>{formattedDate}</span>;
      } catch {
        return <span>{value}</span>;
      }
    }

    case "subject": {
      if (!value) return <span>-</span>;
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {value}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{value}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    case "sender":
    case "listener_email": {
      if (!value) return <span>-</span>;
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {value}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{value}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    case "recipient_list": {
      if (!value || (Array.isArray(value) && value.length === 0))
        return <span>-</span>;
      const text = Array.isArray(value) ? value.join(", ") : String(value);
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {text}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{text}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    case "attachment_list": {
      if (!Array.isArray(value) || value.length === 0) return <span>-</span>;
      const text = value.map((item: any) => item.filename).join(", ");
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1">
              {value.length} file{value.length > 1 ? "s" : ""}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{text}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    case "provider": {
      if (!value) return <span>-</span>;
      return <Badge variant={"outline"} className="capitalize">{value}</Badge>;
    }

    case "error": {
      if (!value) return <span>-</span>;
      return (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger className="text-left line-clamp-1 text-red-500">
              {value}
            </TooltipTrigger>
            <TooltipContent>
              <TooltipArrow />
              <p>{value}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    default: {
      if (value === undefined || value === null || value === "")
        return <span>-</span>;
      return <span>{String(value)}</span>;
    }
  }
};
